<section class="sf-card">
  <div class="section-head">
    <h3 class="section-title">{{ isAdding ? "Adicionar cliente" : "Clientes" }}</h3>
    <button
      type="button"
      class="sf-btn sf-btn--primary sf-btn--sm"
      (click)="showAddForm()"
      *ngIf="!isAdding"
    >
      <i class="fa fa-plus"></i> Adicionar
    </button>
  </div>

  <div *ngIf="isAdding">
    <div class="search-wrap mb-3">
      <i class="fa fa-search"></i>
      <input
        type="text"
        #filterInput
        name="filter"
        id="filter"
        class="form-control"
        [(ngModel)]="filter"
        placeholder="Digite nome, telefone ou email para pesquisar"
        (keypress)="keypress($event)"
      />
      <button type="button" class="search-go" aria-label="Pesquisar" (click)="search()">
        <i class="fa fa-search"></i>
      </button>
    </div>

    <div *ngIf="users$ | async as users; else searchingUsers">
      <table class="table">
        <caption>
          {{
            users.length
          }}
          usuário(s) encontrado(s)
        </caption>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Email</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users">
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td>
              <button class="sf-btn sf-btn--primary sf-btn--sm" [appLoadingButton]="addingId === user.id"
                (click)="add(user)">
                Adicionar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="form-actions mt-2">
      <button
        type="button"
        class="sf-btn sf-btn--ghost"
        (click)="isAdding = false"
      >
        Cancelar
      </button>
    </div>
  </div>

  <div *ngIf="!isAdding">
    <div *ngIf="clients$ | async as result; else clientsLoading">
      <div *ngIf="result.data.length > 0; else noClients">
        <table class="table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Saldo</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let client of result.data">
              <td>{{ client.name }}</td>
              <td>{{ client.email }}</td>
              <td><app-account-balance [source]="client" mode="cell"></app-account-balance></td>
              <td>
                <button class="sf-btn sf-btn--danger sf-btn--icon sf-btn--sm" [appLoadingButton]="deletingId === client.id"
                  aria-label="Excluir cliente" (click)="delete(client)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <app-pagination
          *ngIf="result"
          look="v2"
          [currentPage]="result.current_page"
          [itemsPerPage]="result.per_page"
          [totalItems]="result.total"
          (pageChanged)="pageChanged($event)"
        ></app-pagination>
      </div>
    </div>
  </div>
</section>

<ng-template #noClients>
  <p class="field-hint" *ngIf="!isAdding">Nenhum cliente.</p>
</ng-template>

<ng-template #clientsLoading>
  <app-skeleton variant="table-row" [count]="4" [columns]="3"
    label="Carregando os clientes" data-testid="clients-loading"></app-skeleton>
</ng-template>

<!-- `*ngIf="users$"` para o esqueleto não aparecer antes da primeira busca:
     sem termo pesquisado não há requisição nenhuma em curso. -->
<ng-template #searchingUsers>
  <app-skeleton *ngIf="users$" variant="table-row" [count]="3" [columns]="3"
    label="Procurando usuários" data-testid="users-search-loading"></app-skeleton>
</ng-template>
